// Cliente Firebase (opcional) para login social. Configurado via VITE_FIREBASE_*.
// Sem config, `isFirebaseConfigured` é false e o botão social não é exibido.
const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = !!(cfg.apiKey && cfg.projectId && cfg.appId);

let authInstance = null;

const ensureAuth = async () => {
  if (authInstance) return authInstance;
  const { initializeApp } = await import('firebase/app');
  const { getAuth } = await import('firebase/auth');
  authInstance = getAuth(initializeApp(cfg));
  return authInstance;
};

/** Abre o popup do Google e devolve o ID token do Firebase. */
export const signInWithGoogle = async () => {
  const auth = await ensureAuth();
  const { GoogleAuthProvider, signInWithPopup } = await import('firebase/auth');
  const result = await signInWithPopup(auth, new GoogleAuthProvider());
  return result.user.getIdToken();
};
